import { useMemo } from 'react';
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import reduxMulti from 'redux-multi';
import { reducer } from '../app/reducers/index';
// import { composeWithDevTools } from 'redux-devtools-extension'
import persistentStateMiddleware from '../app/middlewares/persistentStateMiddleware';

const composeEnhancers =
    typeof window !== 'undefined'
        ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
        : compose;

let store;
const initialState = undefined;

function initStore(preloadedState = initialState) {
    return createStore(
        reducer,
        preloadedState,
        composeEnhancers(
            applyMiddleware(
                thunk,
                persistentStateMiddleware,
                reduxMulti
            )
        )
        // composeWithDevTools(applyMiddleware())
    );
}

export const initializeStore = (preloadedState, serverStore) => {
    if (typeof window === 'undefined' && serverStore) {
        return serverStore;
    }

    let _store = store ?? initStore(preloadedState);

    // For SSG and SSR always create a new store
    if (typeof window === 'undefined') return _store;
    // Create the store once in the client
    if (!store) store = _store;

    return _store;
};

export function useClientStore(initialState, serverStore) {
    const store = useMemo(() => initializeStore(initialState, serverStore), [
        initialState,
        serverStore,
    ]);

    return store;
}

export function createServerStore(initialState) {
    const store = initializeStore(initialState);

    return store;
}
